import { render, staticRenderFns } from "./ConfigIntegrationSources.vue?vue&type=template&id=81cd5290&scoped=true&"
import script from "./ConfigIntegrationSources.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationSources.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationSources.vue?vue&type=style&index=0&id=81cd5290&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd5290",
  null
  
)

export default component.exports